import {
  RESET_QUIZ,
  AUTOLOGIN
} from "../action/quizAction";

const initialState = {
  autologindata:''
};

export default function quizReducer(state = initialState, action) {
  switch (action.type) {
    case AUTOLOGIN:
      return {
        ...state,
        autologindata: action.payload,
      };
    case RESET_QUIZ:
      return {
    ...initialState,
  };
    default:
      return state;
  }
}
